import { render, staticRenderFns } from "./TCol.vue?vue&type=template&id=9e601f28&scoped=true&"
import script from "./TCol.vue?vue&type=script&lang=js&"
export * from "./TCol.vue?vue&type=script&lang=js&"
import style0 from "./TCol.vue?vue&type=style&index=0&id=9e601f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e601f28",
  null
  
)

export default component.exports